


















import { Component } from 'nuxt-property-decorator'
import base from '~/components/tour/section-list/recommend-activity-section/card/base'
import RwdSwiper from '~/components/experience/rwd-swiper/index.vue'
import TnaActivityCard from '~/components/tour/tna-activity-card/index.vue'

@Component({
  components: {
    TnaActivityCard,
    RwdSwiper
  }
})
export default class RecommendActivity extends base {
}
